module.exports = __webpack_public_path__ + "img/TZS09612.d0f4ac9b.jpeg";